import $ from 'jquery';
import { getState } from '~src/state';

export function updateTextBorderThicknessControl() {
  let strokeWidth;
  const activeObject = getState('activeObject');

  // If ActiveSelection of texts, derive common or leave blank
  if (
    activeObject &&
    activeObject.type === 'activeSelection' &&
    typeof activeObject.getObjects === 'function'
  ) {
    const texts = activeObject
      .getObjects()
      .filter((o) => o.type === 'textbox' || o.type === 'i-text');
    if (texts.length) {
      const widths = Array.from(
        new Set(texts.map((t) => parseInt(t.get('strokeWidth') || 0, 10)))
      );
      if (widths.length === 1) {
        strokeWidth = widths[0];
      } else {
        strokeWidth = '';
      }
      $('#editor-text-border-thickness-slider').val(strokeWidth || 0);
      $('#editor-text-border-thickness-value').val(strokeWidth);
      return;
    }
  }

  if (activeObject.isEditing) {
    const { selectionStart, selectionEnd } = activeObject;

    if (
      activeObject.text &&
      selectionStart === 0 &&
      selectionEnd === activeObject.text.length
    ) {
      strokeWidth = activeObject.get('strokeWidth');
    } else if (selectionStart === selectionEnd) {
      strokeWidth = activeObject.get('strokeWidth');
    } else {
      const selectionStyles = activeObject.getSelectionStyles();
      if (selectionStyles && selectionStyles.length > 0 && selectionStyles[0]) {
        strokeWidth =
          selectionStyles[0]['strokeWidth'] || activeObject.get('strokeWidth');
      } else {
        strokeWidth = activeObject.get('strokeWidth');
      }
    }
  } else {
    strokeWidth = activeObject.get('strokeWidth');
  }

  $('#editor-text-border-thickness-slider').val(strokeWidth || 0);
  $('#editor-text-border-thickness-value').val(strokeWidth || 0);
}
